import { NgModule } from '@angular/core';
import { FooterComponent } from './footer/footer.component';
import { TopNavbarComponent } from './top-navbar/top-navbar.component';



@NgModule({
  declarations: [],
  imports: [
    TopNavbarComponent,
    FooterComponent
  ],
  exports: [
    TopNavbarComponent,
    FooterComponent,
  ]
})
export class NavigationModule { }
